import { EsgEligibilityIcon } from 'components/esg-eligibility/esg-eligibility-icon';
import { EligibilityInfo } from 'components/esg-eligibility/esg-eligibility-info';
import { HeaderCell } from 'components/shared/underlyings/underlyingsGridLegacy/Table/Common/HeaderCell';
import { FormattedMessage } from 'react-intl';

function Header() {
  return (
    <HeaderCell data-column="esg-eligibility" className="px-0" style={{ maxWidth: '20px' }}>
      <div className="flex-x flex-wrap text-center justify-content-center" style={{ gap: '0px 8px' }}>
        <FormattedMessage id="quote.underlyingsGrid.header.ESGScore.legacy" />
        <EligibilityInfo />
      </div>
    </HeaderCell>
  );
}

type CellProps = {
  isEligible?: boolean;
  isEligibleWithCondition?: boolean;
};

function Data(props: CellProps) {
  return (
    <td data-column="esg-eligibility" className="align-middle px-1 text-center">
      <EsgEligibilityIcon {...props} size="sm" />
    </td>
  );
}

export const EsgEligibilityCell = { Header, Data };
